// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".email-form[data-v-19779706] {\n  max-width: 600px;\n}", "",{"version":3,"sources":["webpack://./resources/js/modules/email/components/EmailEdit.vue"],"names":[],"mappings":"AACA;EACI,gBAAA;AAAJ","sourcesContent":["\n.email-form {\n    max-width: 600px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
